<!-- DESKTOP -->
<div class="desktop edp-card-widget card">
    <div class="card-header">
        <span class="card-title">{{ 'pt.edp.edponline.widget.benefits.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-086"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body">
        <span class="icon">
            <i class="icon-edponline-Bra-144"  aria-hidden="true"></i>
        </span>
        <span class="description">
            <ng-container *ngIf="expiringCode?.type === '0'">
                {{ 'pt.edp.edponline.widget.codes.text.code' | translate }}
            </ng-container>
            <ng-container *ngIf="expiringCode?.type === '1'">
                {{ 'pt.edp.edponline.widget.codes.text.link' | translate }}
            </ng-container>
            <b> {{ expiringCode?.name }}</b>
            {{ 'pt.edp.edponline.widget.codes.text2' | translate }}
             {{ expiringCode.validity_date |  date:'d MMMM, y'}}
            </span>
        <div class="share">
            <div class="share-text">
                <span class="title" *ngIf="expiringCode?.type === '0'">
                    {{ 'pt.edp.edponline.widget.codes.title' | translate }}
                </span>
                <span class="title" *ngIf="expiringCode?.type === '1'">
                    {{ 'pt.edp.edponline.widget.codes.link.title' | translate }}
                </span>
                <span class="code">{{ expiringCode?.code }}</span>
            </div>
            
            <div class="d-inline-block share-icon">
                <i class="icon-edponline-Bop-088"  aria-hidden="true"></i>
            </div>
        </div>
    </div>
</div>



<!-- MOBILE -->
<div class="mobile edp-card-widget card">
    <div class="card-header">
        <span class="card-title-small">{{ 'pt.edp.edponline.widget.benefits.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-086"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body">
        <div class="share-mobile">
            <span class="description-mobile">
                <ng-container *ngIf="expiringCode?.type === '0'">
                    {{ 'pt.edp.edponline.widget.codes.text.code.mobile' | translate }}
                </ng-container>
                <ng-container *ngIf="expiringCode?.type === '1'">
                    {{ 'pt.edp.edponline.widget.codes.text.link.mobile' | translate }}
                </ng-container>
                <b>{{ expiringCode?.code }}</b>
                {{ 'pt.edp.edponline.widget.codes.text.code.mobile2' | translate }}
                <b>{{ expiringCode?.name }}</b>
                {{ 'pt.edp.edponline.widget.codes.text2' | translate }} 
                 {{ expiringCode?.validity_date |  date: 'd MMMM, y'}}
            </span>
            <div class="d-inline-block share-icon">
                <i class="icon-edponline-Bop-088"  aria-hidden="true"></i>
            </div>
        </div>
    </div>
</div>

